import { IChannelRepository } from '../../ports/IChannelRepository';

export class GetChannelUseCase {
  constructor(private repo: IChannelRepository) {}
  execute(uuid: string) { return this.repo.get(uuid); }
}
